import { render } from "./ProductLoaderComponent.vue?vue&type=template&id=d32042d8&scoped=true"
const script = {}

import "./ProductLoaderComponent.vue?vue&type=style&index=0&id=d32042d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32042d8"]])

export default __exports__